import { render } from "./uiForm.vue?vue&type=template&id=7023559d"
import script from "./uiForm.vue?vue&type=script&lang=js"
export * from "./uiForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__